/**
 * @flow
 * @relayHash 0074a870f22a9d89a4fde2d1deb5689e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UndoMSDocumentUploadMutationInput = {
  objectId: number,
  isDocument?: ?boolean,
  isImport?: ?boolean,
  deletedAttachments?: ?string,
  newAttachmentIds?: ?$ReadOnlyArray<?number>,
  clientMutationId?: ?string,
};
export type undoMSWordUploadMutationVariables = {|
  input: UndoMSDocumentUploadMutationInput
|};
export type undoMSWordUploadMutationResponse = {|
  +undoMswordUpload: ?{|
    +ok: ?boolean,
    +reasons: ?any,
  |}
|};
export type undoMSWordUploadMutation = {|
  variables: undoMSWordUploadMutationVariables,
  response: undoMSWordUploadMutationResponse,
|};
*/


/*
mutation undoMSWordUploadMutation(
  $input: UndoMSDocumentUploadMutationInput!
) {
  undoMswordUpload(input: $input) {
    ok
    reasons
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UndoMSDocumentUploadMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "undoMswordUpload",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UndoMSDocumentUploadMutationInput!"
      }
    ],
    "concreteType": "UndoMSDocumentUploadMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ok",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "reasons",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "undoMSWordUploadMutation",
  "id": "2db95cc8f12919247f05ec1900f27e05",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "undoMSWordUploadMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "undoMSWordUploadMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "mutation undoMSWordUploadMutation(\n  $input: UndoMSDocumentUploadMutationInput!\n) {\n  undoMswordUpload(input: $input) {\n    ok\n    reasons\n  }\n}\n";
(node/*: any*/).hash = '932f6b8d98596bfe4a276acb28ba8c80';
module.exports = node;
